<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.telefone_residencial"
                    label="Telefone residencial"
                    v-mask="utils.mask.telefone"
                    v-model="model.telefone_residencial"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.telefone_celular"
                    label="Telefone celular"
                    v-mask="utils.mask.celular"
                    v-model="model.telefone_celular"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    v-if="['', null, undefined].includes(model.telefone_recado)"
                    :validations="validations.telefone_recado"
                    label="Telefone de recado"
                    v-model="model.telefone_recado"
                />

                <rkm-form-input
                    v-else-if="model.telefone_recado.length < 15"
                    :validations="validations.telefone_recado"
                    label="Telefone de recado"
                    v-mask="utils.mask.telefone"
                    v-model="model.telefone_recado"
                />

                <rkm-form-input
                    v-else
                    :validations="validations.telefone_recado"
                    label="Telefone de recado"
                    v-mask="utils.mask.celular"
                    v-model="model.telefone_recado"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :validations="validations.email"
                    label="E-mail"
                    v-model="model.email"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Utils.
import mask from '@/utils/mask'

export default {
    computed: {
        validations() {
            return {
                telefone_residencial: {
                    min: 14,
                    max: 14,
                },
                telefone_celular: {
                    required: true,
                    min: 15,
                    max: 15,
                },
                telefone_recado: {
                    min: 14,
                    max: 15,
                },
                email: {email: true},
            }
        },
    },
    data: () => ({
        utils: {mask},
    }),
    methods: {
        validate() {
            return this.$refs.RkmForm.validate()
        },
    },
    props: {
        model: {type: Object, required: true},
    },
}
</script>